
import AppLayout from '../../components/layout/app-layout/app-layout';
import Tabs from '../../components/shared/Tabs';
import { FC, useState, useMemo } from 'react';
import styles from './page-updates.module.scss';
import appState from '../../state/AppStateContainer';
import { useTranslation } from 'react-i18next';

const CampaignArchive: FC<{archiveSrc: string}> = ({archiveSrc}) => {
  const srcDoc=`
    <style type="text/css">
      <!--
      body { margin: 0 }
      .display_archive { font-family: Inter, sans-serif; font-size: 16px; }
      .campaign { margin: 0 0 10px 0; }
      //-->
    </style>
    <script language="javascript" src="${archiveSrc}" type="text/javascript"></script>`;
  return <iframe title={'archive'} srcDoc={srcDoc}></iframe>
};

const PageUpdates = () => {
  const [t] = useTranslation('updates');
  const [selectedTab, setSelectedTab] = useState(0);

  const updates = useMemo(() => [
    {
      name: t('tabs.purchasing', 'För inköpare'),
      active: appState.isPurchasingActive(),
      intro: t('intro.purchasing', 'Här hittar du våra 10 senaste nyhetsbrev om förändringar i Accurator.'),
      archiveSrc: '//accurator.us5.list-manage.com/generate-js/?u=0f29c0eb3cd43b10a9c4fec49&fid=64645&show=10'
    },
    {
      name: t('tabs.sales', 'För leverantörer'),
      active: appState.isSalesActive(),
      intro: t('intro.sales', 'Här hittar du våra 10 senaste nyhetsbrev om förändringar i Accurator.'),
      archiveSrc: '//accurator.us5.list-manage.com/generate-js/?u=0f29c0eb3cd43b10a9c4fec49&fid=64756&show=10'
    }
  ], [t]);

  const visibleTabs = updates.filter(x => x.active).map(x => x.name);

  const selectedUpdates = updates.find(x => x.name === visibleTabs[selectedTab]);

  return (
    <AppLayout title={t('pageTitle', 'Uppdateringar i Accurator')}>
      <div className={styles.pageUpdates}>
        <Tabs tabs={visibleTabs} selected={selectedTab} onChange={setSelectedTab} />
        { selectedUpdates &&
          <div className={styles.container}>
            <p>{selectedUpdates.intro}</p>
            <CampaignArchive archiveSrc={selectedUpdates.archiveSrc} />
          </div>
        }
      </div>
    </AppLayout>
  );
};

export default PageUpdates;
